import { render, staticRenderFns } from "./PackageFormDialog.vue?vue&type=template&id=26117750&scoped=true"
import script from "./PackageFormDialog.vue?vue&type=script&lang=js"
export * from "./PackageFormDialog.vue?vue&type=script&lang=js"
import style0 from "./PackageFormDialog.vue?vue&type=style&index=0&id=26117750&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26117750",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26117750')) {
      api.createRecord('26117750', component.options)
    } else {
      api.reload('26117750', component.options)
    }
    module.hot.accept("./PackageFormDialog.vue?vue&type=template&id=26117750&scoped=true", function () {
      api.rerender('26117750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/PackageFormDialog.vue"
export default component.exports